import { getBoolEnv } from 'components/util/get-bool-env';

export const GTM = process.env.REACT_APP_GTM;
// build string
export const AXLE_BUILD = process.env.REACT_APP_AXLE_BUILD;
export const AXLE_VERSION = process.env.REACT_APP_AXLE_VERSION;
export const DISABLE_SECURE_COOKIE = getBoolEnv(
  process.env.REACT_APP_DISABLE_SECURE_COOKIE,
);

